export const LOAD_DEPARTMENTS = "LOAD_DEPARTMENTS";
export const GET_DEPARTMENTS_AND_EMPLOYEES = "GET_DEPARTMENTS_AND_EMPLOYEES";
export const CREATE_DEPARTMENTS = "CREATE_DEPARTMENTS";
export const DELETE_DEPARTMENTS = "DELETE_DEPARTMENTS";
export const ADD_EMPLOYEES_TO_DEPARTMENT = "ADD_EMPLOYEES_TO_DEPARTMENT";
export const DELETE_EMPLOYEES_FROM_DEPARTMENT =
  "DELETE_EMPLOYEES_FROM_DEPARTMENT";
